module.exports = __webpack_public_path__ + "img/logo-prisma-vertical.a4ab3ba9.svg";